import {
  AppSpan,
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
  FormGroupWithIcon,
  GridContainer,
  Input,
  ReactSelect,
} from "src/style";
import { customStyles } from "src/component/Table/style";
import React, { useState, useEffect, useContext } from "react";
import DataTable, { Direction } from "react-data-table-component";
import { FiChevronDown, FiSearch } from "react-icons/fi";
import "../Table/style.scss";
import helpers from "src/utils/helpers";
import { BsFilter } from "react-icons/bs";
import { FiTrash } from "react-icons/fi";
import { ReactComponent as NoDataIcon } from "src/assets/img/no-data-icon.svg";
import { useTranslation } from "react-i18next";
import { OptionType } from "src/model";
import ApiContext from "src/provider/API/call-service";
import utility from "src/utils/utility";
import { FiPlus } from "react-icons/fi";


export const ServerSideTable: React.FC<any> = React.memo(
  ({
    tableData,
    tableColumns,
    dataFetchMethod,
    totalRows,
    pageNumber,
    callOnMount,
    customStyle,
    canSearch,
    canFilter,
    canClear,
    tableTitle,
    shouldResetPagination,
    downloadAction,
    selectInstitution,
    onInstitutionSelect,
    showSurvey,
    summaryData,
    showCreate,
    setShowAddTriggger,
  }) => {
    const { API } = useContext(ApiContext);
    const { t } = useTranslation();
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(pageNumber || 1);
    const [mockTableData, setMockTableData] = useState<any[]>([]);
    const [allInstitutions, setAllInstitutions] = useState<any>([]);
    const institutions: OptionType[] = allInstitutions?.map(
      (institution: any) => ({ label: institution.name, value: institution.id })
    );

    const [input, setInput] = useState({
      institutionCode: "",
    });

    const handleInput = (
      e: React.ChangeEvent<
        HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
      >
    ) => {
      const { name, value } = e.target;
      setInput({ ...input, [name]: value });

      if (name === "institutionCode" && onInstitutionSelect) {
        onInstitutionSelect(value);
      }
    };

    useEffect(() => {
      if (callOnMount) dataFetchMethod(pageNumber, perPage);
    }, []);

    useEffect(() => {
      setCurrentPage(1);
    }, [pageNumber, shouldResetPagination]);

    useEffect(() => {
      setMockTableData(tableData);
    }, [tableData]);

    async function handleFetchInstitution() {
      const response = await API.getAllInstitutions();
      if (response?.length)
        setAllInstitutions(
          helpers.sortItemsWIthString(response, "name", "asc")
        );
    }

    useEffect(() => {
      if (selectInstitution) handleFetchInstitution();
    }, []);

    function handleDataSearching(e: React.ChangeEvent<HTMLInputElement>) {
      const filteredData = helpers.searchTableData(tableData, e.target.value);
      setMockTableData(filteredData);
    }

    const handlePageChange = (page: any) => {
      dataFetchMethod(page, perPage);
      setCurrentPage(page);
    };

    const handlePerRowsChange = async (
      newPerPage: React.SetStateAction<number>,
      page: any
    ) => {
      dataFetchMethod(page, newPerPage);
      setPerPage(newPerPage);
    };

    return (
      <>
        <FlexRow
          justifyContent="space-between"
          wrap="wrap"
          gap="2.5"
          bottomMargin="2.5"
          className="table-header-container"
        >
          {tableTitle && (
            <AppText textSize="3" color="#101828" fontWeight="600">
              {tableTitle}
            </AppText>
          )}
          <FlexRow
            //width={!canClear ? '50' : '60'}
            width="100"
            sizeUnit="%"
            gap="1.5"
            justifyContent="flex-end"
            className="search-box-wrapper"
          >
            {selectInstitution && (
              <CustomContainer
                radius="0.8"
                borderColor="#D0D5DD"
                rightPadding="1.5"
                //   className={!canClear ? 'search-box' : 'search-box-plus'}
                style={{
                  border: "none",
                  width: "30%",
                  position: "absolute",
                  left: "0",
                }}
              >
                <ReactSelect
                  bottomMargin="1.5"
                  topMargin="1"
                  styles={utility.reactSelectStyles()}
                  options={institutions?.map((item: any, index: number) => {
                    return {
                      label: item.label,
                      value: item.value,
                      key: index,
                    };
                  })}
                  isClearable={true}
                  isSearchable={true}
                  name="institutionCode"
                  placeholder="Select Institution"
                  menuPortalTarget={document.body}
                  value={
                    input?.institutionCode
                      ? {
                          label: input?.institutionCode,
                          value: input?.institutionCode,
                        }
                      : null
                  }
                  onChange={(val: any) => {
                    onInstitutionSelect(val);
                    setInput({ ...input, institutionCode: val?.label || "" });
                  }}
                />

                {/* <FormGroupWithIcon>
                  <div className="input-with-icon">
                    <select
                      name="institutionCode"
                      value={input.institutionCode}
                      onChange={handleInput}
                      autoComplete="off"
                      required
                    >
                      <option value="">Select Institution</option>
                      {institutions.map((institution: any, index: number) => (
                        <option key={index} value={institution.value}>
                          {institution.label}
                        </option>
                      ))}
                    </select>
                    <FiChevronDown className="input-with-icon-tag" />
                  </div>
                </FormGroupWithIcon> */}
              </CustomContainer>
            )}

            {canSearch && (
              <CustomContainer
                radius="0.8"
                borderColor="#D0D5DD"
                leftPadding="1.5"
                rightPadding="1.5"
                shadow="0px 1px 2px rgba(16, 24, 40, 0.05)"
                className={!canClear ? "search-box" : "search-box-plus"}
              >
                <FlexRow>
                  <FiSearch style={{ fontSize: "2rem", color: "#667085" }} />
                  <Input
                    height="4"
                    leftPadding="1"
                    placeholder={t("serverSideTable.searchPlaceholder")}
                    onChange={handleDataSearching}
                  />
                </FlexRow>
              </CustomContainer>
            )}
            {canFilter && (
              <GridContainer
                width="10.2"
                height="4"
                radius="0.8"
                borderColor="#D0D5DD"
                onClick={canFilter}
              >
                <FlexRow width="auto" sizeUnit="">
                  <BsFilter
                    style={{
                      fontSize: "2rem",
                      color: "#344054",
                      marginRight: "1rem",
                    }}
                  />
                  <AppSpan fontWeight="600" color="#344054" cursor="pointer">
                    {t("serverSideTable.filters")}
                  </AppSpan>
                </FlexRow>
              </GridContainer>
            )}
            {canClear && (
              <GridContainer
                width="11.8"
                height="4"
                radius="0.8"
                borderColor="#D0D5DD"
                onClick={canClear}
              >
                <FlexRow width="auto" sizeUnit="">
                  <FiTrash
                    style={{
                      fontSize: "1.7rem",
                      color: "#344054",
                      marginRight: "1rem",
                    }}
                  />
                  <AppSpan fontWeight="600" color="#344054" cursor="pointer">
                    {t("serverSideTable.clearAll")}
                  </AppSpan>
                </FlexRow>
              </GridContainer>
            )}
            {downloadAction && (
              <Button
                width="15"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                // hoverBgColor='#fff' borderColor='#0D968F'
                // hoverColor='#0D968F'
                color="#344054"
                borderColor="#D0D5DD"
                bgColor="#fff"
                onClick={downloadAction}
              >
                {t("serverSideTable.download")}
              </Button>
            )}

            {showCreate && (<Button
              width="22"
              titleSize="1.4"
              fontWeight="600"
              height="4"
              radius="0.8"
              borderColor="#D0D5DD"
              hoverColor="#ffffffb9"
              className="update-billers-btn"
              onClick={setShowAddTriggger}
            >
              <FlexRow alignItems="center" justifyContent="center">
              <FiPlus size={20} color="#fff" />
              Add New Survey
              </FlexRow>
            </Button>)}
          </FlexRow>
        </FlexRow>

        {showSurvey && input.institutionCode && (
          <FlexRow gap="2" bottomMargin="2" justifyContent="space-between">
            <>
              {summaryData?.map((item: any, index: number) => (
                <FlexColumn
                  key={index}
                  padding="1"
                  width="29"
                  height="12"
                  borderWidth="2"
                  borderColor="#E5E7EB"
                  radius="1"
                >
                  <FlexRow>
                    {item?.icon}
                    <FlexColumn leftMargin="1" alignItems="start">
                      <AppText textSize="1.4" fontWeight="600" color="#6B7280">
                        {item?.label}
                      </AppText>
                      <AppText textSize="4" fontWeight="700" color="#111827">
                        {item?.value || 0}
                      </AppText>
                      {item?.totalValue && (
                        <AppText>Total: {item.totalValue}</AppText>
                      )}
                    </FlexColumn>
                  </FlexRow>
                </FlexColumn>
              ))}
            </>
          </FlexRow>
        )}

        {(tableData && tableData?.length > 0) ||
        (selectInstitution && input.institutionCode) ? (
          <div className="table-wrapper">
            <DataTable
              columns={tableColumns}
              data={mockTableData?.length ? mockTableData : tableData}
              striped
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              // paginationResetDefaultPage={shouldResetPagination}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              customStyles={customStyle ? customStyles : undefined}
            />
          </div>
        ) : (
          <GridContainer
            minHeight="25"
            borderColor="#E2E8F0"
            radius="0.3"
            padding="2"
          >
            <FlexColumn width="auto" sizeUnit="">
              <NoDataIcon className="icon-component" />
              <AppText
                align="center"
                color="#101828"
                textSize="1.6"
                fontWeight="600"
              >
                {selectInstitution && !input.institutionCode
                  ? "Kindly select an institutuion to view records"
                  : t("serverSideTable.noRecordsFound")}
              </AppText>
            </FlexColumn>
          </GridContainer>
        )}
      </>
    );
  }
);
